// src/analytics/eventNames.ts

export enum EventNames {
    SIGNUP_CLICKED = "Signup Clicked",
    SIGNUP_COMPLETED = "Signup Completed",
    SIGNUP_FAILED = "Signup Failed",
    REFERRAL_LINK_COPIED = "Referral Link Copied",
    MOBILE_APP_PROMPT_SHOWN = "Mobile App Prompt Shown",
    MOBILE_APP_PROMPT_DISMISSED = "Mobile App Prompt Dismissed",
    APP_OPEN_ATTEMPTED = "App Open Attempted",
    STORE_HANDOFF_STARTED = "Store Handoff Started",
    LOGIN_SUCCESS = "Login Success",
    LOGIN_FAILED = "Login Failed",
    LOGIN_VERIFIED = "Login Verified",
    LOGIN_VERIFICATION_FAILED = "Login Verification Failed",
    LOGIN_WITH_GOOGLE = "Login With Google",
    LOGIN_WITH_GOOGLE_FAILED = "Login With Google Failed",
    LOGIN_WITH_APPLE = "Login With Apple",
    LOGIN_WITH_APPLE_FAILED = "Login With Apple Failed",
    SONG_PLAYED = "Song Played",
    SONG_STEM_PLAYED = "Song Stem Played",
    SONG_PAUSED = "Song Paused",
    SONG_ADDED_TO_REHEARSAL = "Song Added to Rehearsal",
    MULTITRACK_PLAYER_OPENED = "Multitrack Player Opened",
    UPGRADE_INITIATED = "Upgrade Initiated",
    UPGRADE_CARD_CLICKED = "Upgrade Card Clicked",
    FEEDBACK_SUBMITTED = "Feedback Submitted",
    REEL_VIEWED = "Reel Viewed",
    CREATE_CHOIR_CLICKED = "Create Choir Clicked",
    CREATE_CHOIR_SUBMITTED = "Create Choir Submitted",
    CREATE_CHOIR_FAILED = "Create Choir Failed",
    JOIN_CHOIR_REQUEST = "Join Choir",
    JOIN_CHOIR_REQUEST_FAILED = "Join Choir Request Failed",
    CHOIR_JOINED = "Choir Joined",
    PRACTICE_CLICKED = "Practice Clicked",
    PRACTICE_SUBMITTED = "Practice Submitted",
    CHOIR_PRACTICE_SUBMITTED = "Choir Practice Submitted",
    DIRECTOR_FEEDBACK_GIVEN = "Director Feedback Given",
    ANONYMOUS_USER_CREATED = "Anonymous User Created",
    VIEW_SONG_IN_REHEARSAL = "View Song In Rehearsal",
    TAG_CLICKED = "Tag Clicked",
    LYRICS_TYPE_CLICKED = "Lyrics Type Clicked",
    SHOW_PIANO = "Show Piano",
    SHOW_CHOIR_VIDEO_CHAT = "Show Choir Video Chat",
    SHOW_CHOIR_TEXT_CHAT = "Show Choir Text Chat",
    VIEW_AI_FEEDBACK = "View AI Feedback",
    WHITELIST_ROLE_REQUEST_CLICKED = "Whitelist Role Request Clicked",
    DIRECTOR_ROLE_REQUEST_CLICKED = "Director Role Request Clicked",
    WHITELIST_ROLE_REQUEST_SUBMITTED = "Whitelist Role Request Submitted",
    DIRECTOR_ROLE_REQUEST_SUBMITTED = "Director Role Request Submitted",
    WHITELIST_ROLE_REQUEST_FAILED = "Whitelist Role Request Failed",
    DIRECTOR_ROLE_REQUEST_FAILED = "Director Role Request Failed",
    CHOIR_SEAT_INSUFFICIENT_JOIN_REQUEST_APPROVAL = "Choir Seat Insufficient Join Request Approval",
    CHOIR_SEAT_INSUFFICIENT_PROJECT_SYNC = "Choir Seat Insufficient Project Sync",
    CHOIR_INVITATION_PENDING_DIRECTOR_ACTION = "Choir Invitation Pending Director Action",
    PAGE_VIEWED = "Page Viewed",
    // PUBLIC EVENTS
    PUBLIC_CHOIR_SONG_HARMONY_LOADED = "Public Song Loaded",
    PUBLIC_SIGNUP_CLICKED = "Public Signup Clicked",
    PUBLIC_CHOIR_SONG_HARMONY_PLAYED = "Public Song Played",
    PUBLIC_CHOIR_SONG_HARMONY_PAUSED = "Public Song Paused",
    PUBLIC_CHOIR_SONG_HARMONY_STEM_MUTED = "Public Song Stem Muted",
    PUBLIC_CHOIR_SONG_HARMONY_STEM_UNMUTED = "Public Song Stem Unmuted",
    PUBLIC_CHOIR_SONG_HARMONY_STEM_SOLOED = "Public Song Stem Soloed",
    PUBLIC_CHOIR_SONG_HARMONY_STEM_UNSOLOED = "Public Song Stem Unsoloed",
    PUBLIC_PLAYER_MODE_CHANGED = "Public Player Mode Changed",
    ONBOARDING_ROLE_SELECTED = "Onboarding Role Selected",
    ONBOARDING_PART_SELECTED = "Onboarding Part Selected",
    ONBOARDING_USERNAME_CONFIRMED = "Onboarding Username Confirmed",
    ONBOARDING_RECOMMENDATION_ACCEPTED = "Onboarding Recommendation Accepted",
    ONBOARDING_V2_SHOWN = "Onboarding V2 Shown",
    ONBOARDING_V2_DISMISSED = "Onboarding V2 Dismissed",
    ONBOARDING_V2_RESUMED = "Onboarding V2 Resumed",
    ONBOARDING_V2_STEP_COMPLETED = "Onboarding V2 Step Completed",
    ONBOARDING_V2_CTA_SHOWN = "Onboarding V2 CTA Shown",
    ONBOARDING_V2_CTA_CLICKED = "Onboarding V2 CTA Clicked",
    ONBOARDING_V2_CTA_DISMISSED = "Onboarding V2 CTA Dismissed",
    ONBOARDING_V2_ACTION_COMPLETED = "Onboarding V2 Action Completed",
    ONBOARDING_V2_ACTIVATION_REACHED = "Onboarding V2 Activation Reached",
    ONBOARDING_V2_AHA_REACHED = "Onboarding V2 Aha Reached",
    QUICK_START_OPENED = "Quick Start Opened",
    QUICK_START_ITEM_CLICKED = "Quick Start Item Clicked",
    QUICK_START_ITEM_COMPLETED = "Quick Start Item Completed",
    QUICK_START_DISMISSED = "Quick Start Dismissed",
    QUICK_START_CTA_NAVIGATED = "Quick Start CTA Navigated",
    ONBOARDING_SKIPPED = "Onboarding Skipped",
    MODULE_HELP_HINT_SHOWN = "Module Help Hint Shown",
    MODULE_HELP_HINT_CLICKED = "Module Help Hint Clicked",
    MODULE_HELP_VIDEO_OPENED = "Module Help Video Opened",
    MODULE_HELP_VIDEO_CLOSED = "Module Help Video Closed",
    MODULE_HELP_PROCEED_CLICKED = "Module Help Proceed Clicked",
    SONG_LIBRARY_GUIDE_HINT_SHOWN = "Song Library Guide Hint Shown",
    SONG_LIBRARY_GUIDE_STEP_COMPLETED = "Song Library Guide Step Completed",
    SONG_LIBRARY_GUIDE_DISMISSED = "Song Library Guide Dismissed",
    SONG_LIBRARY_GUIDE_RESUMED = "Song Library Guide Resumed",
    CHOIRS_OVERVIEW_GUIDE_HINT_SHOWN = "Choirs Overview Guide Hint Shown",
    CHOIRS_OVERVIEW_GUIDE_STEP_COMPLETED = "Choirs Overview Guide Step Completed",
    CHOIRS_OVERVIEW_GUIDE_DISMISSED = "Choirs Overview Guide Dismissed",
    CHOIRS_OVERVIEW_GUIDE_RESUMED = "Choirs Overview Guide Resumed",
    CHOIR_REHEARSALS_GUIDE_HINT_SHOWN = "Choir Rehearsals Guide Hint Shown",
    CHOIR_REHEARSALS_GUIDE_STEP_COMPLETED = "Choir Rehearsals Guide Step Completed",
    CHOIR_REHEARSALS_GUIDE_DISMISSED = "Choir Rehearsals Guide Dismissed",
    CHOIR_REHEARSALS_GUIDE_RESUMED = "Choir Rehearsals Guide Resumed",
    CHOIR_REHEARSAL_SONGS_GUIDE_HINT_SHOWN = "Choir Rehearsal Songs Guide Hint Shown",
    CHOIR_REHEARSAL_SONGS_GUIDE_STEP_COMPLETED = "Choir Rehearsal Songs Guide Step Completed",
    CHOIR_REHEARSAL_SONGS_GUIDE_DISMISSED = "Choir Rehearsal Songs Guide Dismissed",
    CHOIR_REHEARSAL_SONGS_GUIDE_RESUMED = "Choir Rehearsal Songs Guide Resumed",
    CHOIR_SETLISTS_GUIDE_HINT_SHOWN = "Choir Setlists Guide Hint Shown",
    CHOIR_SETLISTS_GUIDE_STEP_COMPLETED = "Choir Setlists Guide Step Completed",
    CHOIR_SETLISTS_GUIDE_DISMISSED = "Choir Setlists Guide Dismissed",
    CHOIR_SETLISTS_GUIDE_RESUMED = "Choir Setlists Guide Resumed",
    CHOIR_SETLIST_CREATED = "Choir Setlist Created",
    CHOIR_SCHEDULE_GUIDE_HINT_SHOWN = "Choir Schedule Guide Hint Shown",
    CHOIR_SCHEDULE_GUIDE_STEP_COMPLETED = "Choir Schedule Guide Step Completed",
    CHOIR_SCHEDULE_GUIDE_DISMISSED = "Choir Schedule Guide Dismissed",
    CHOIR_SCHEDULE_GUIDE_RESUMED = "Choir Schedule Guide Resumed",
    CHOIR_MEMBERS_GUIDE_HINT_SHOWN = "Choir Members Guide Hint Shown",
    CHOIR_MEMBERS_GUIDE_STEP_COMPLETED = "Choir Members Guide Step Completed",
    CHOIR_MEMBERS_GUIDE_DISMISSED = "Choir Members Guide Dismissed",
    CHOIR_MEMBERS_GUIDE_RESUMED = "Choir Members Guide Resumed",
    PERSONAL_SETLIST_CREATED = "Personal Setlist Created",
    CHOIR_REHEARSAL_RUNTHROUGH_GUIDE_HINT_SHOWN = "Choir Rehearsal Runthrough Guide Hint Shown",
    CHOIR_REHEARSAL_RUNTHROUGH_GUIDE_STEP_COMPLETED = "Choir Rehearsal Runthrough Guide Step Completed",
    CHOIR_REHEARSAL_RUNTHROUGH_GUIDE_DISMISSED = "Choir Rehearsal Runthrough Guide Dismissed",
    CHOIR_REHEARSAL_RUNTHROUGH_GUIDE_RESUMED = "Choir Rehearsal Runthrough Guide Resumed",
    REHEARSAL_CREATED = "Rehearsal Created",
    CHOIR_MEMBER_INVITED = "Choir Member Invited",
    PROJECT_CREATED = "Project Created",
    PROJECT_APPLICATION_SUBMITTED = "Project Application Submitted",
    PROJECT_ROLE_INVITE_SENT = "Project Role Invite Sent",
    CHALLENGE_INTEREST_EXPRESSED = "Challenge Interest Expressed",
    CHALLENGE_ENTRY_SUBMITTED = "Challenge Entry Submitted",
    CHALLENGE_CREATED = "Challenge Created",
    CONTRIBUTION_FLOW_STARTED = "Contribution Flow Started",
    CONTRIBUTION_UPLOAD_COMPLETED = "Contribution Upload Completed",
    CONTRIBUTION_SUBMITTED = "Contribution Submitted",
    SONG_UPLOAD_COMPLETED = "Song Upload Completed",
    EXERCISE_SKILL_OPENED = "Exercise Skill Opened",
    EXERCISE_RECOMMENDED_OPENED = "Exercise Recommended Opened",
    EXERCISE_DIRECT_GAME_OPENED = "Exercise Direct Game Opened",
    EXERCISE_MODULE_OPENED = "Exercise Module Opened",
    EXERCISE_LOCKED_CLICKED = "Exercise Locked Clicked",
    EXERCISE_STARTED = "Exercise Started",
    EXERCISE_STEP_COMPLETED = "Exercise Step Completed",
    EXERCISE_STEP_RETRIED = "Exercise Step Retried",
    EXERCISE_INFINITE_STARTED = "Exercise Infinite Started",
    EXERCISE_EXITED = "Exercise Exited",
    EXERCISE_COMPLETED = "Exercise Completed",
    EXERCISE_ATTEMPTS_SUBMITTED = "Exercise Attempts Submitted",
    EXERCISE_ATTEMPTS_SUBMIT_FAILED = "Exercise Attempts Submit Failed",
}

export type EventName = `${EventNames}`;
